module.exports = __webpack_public_path__ + "img/img1.66f7a91b.png";